import { Button, type SxProps, type Theme } from "@mui/material";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { getLocation } from "../../utils/routes";
import type { AdminChatMessage, PlacementChannelMetadata } from "../types";
import { parseCustomMessage } from "../utils/parseCustomMessage";
import { ChatMessageCard } from "./ChatMessageCard";

interface PlacementApplicationInterviewScheduledProps {
  message: AdminChatMessage;
  channelMetadata?: PlacementChannelMetadata;
  sx?: SxProps<Theme>;
}

export function PlacementApplicationInterviewScheduled(
  props: PlacementApplicationInterviewScheduledProps
) {
  const { message, channelMetadata, sx } = props;
  const history = useHistory();
  const displayMessage = parseCustomMessage(message.message);

  const navigateToManageJobsPage = useCallback(() => {
    history.push(
      getLocation("manageJobs", {
        queryParams: channelMetadata?.hcpName ? { searchApplicant: channelMetadata.hcpName } : {},
      })
    );
  }, [history, channelMetadata?.hcpName]);

  return (
    <ChatMessageCard
      actions={
        <Button size="small" variant="contained" onClick={navigateToManageJobsPage}>
          Manage jobs
        </Button>
      }
      title={displayMessage}
      sx={sx}
    />
  );
}
